
import firebase from '@/firebase'

// State object
const state = {
  textlinks: [],
}
// Getter functions
const getters = {
  orderedTextlinks: state => {
    return state.textlinks.sort((a,b)=>{ return a.index>b.index?1:-1; });
  }
}
// Actions
const actions = {
  queryTextlinks({state,commit,rootState}) {
    console.log('queryTextlinks')

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const textlinksRef = db.collection('users').doc(rootState.user.uid).collection('textlinks');
    return textlinksRef.get().then(snapshot => {
      console.log('queryTextlinks ok')
      let arr = [];
      var index = 1;
      snapshot.forEach(register => {
        let textlink = { id:register.id, ...register.data() };
        if(!textlink.index) textlink.index = index++;
        textlink.hover = textlink.name+"\n\n"+textlink.url;
        arr.push(textlink);
      });
      commit('setTextlinks',arr);
    });

  },
  changeTextlinkOrder({state,commit,rootState},{textlink_id,index}){
    state.textlinks.forEach((textlink)=>{
      if(textlink.id==textlink_id) textlink.index = index;
      return textlink;
    })
    this.dispatch('reorderTextlinks');
  },
  reorderTextlinks({state,commit,rootState}){
    const db = firebase.firestore();
    const textlinksRef = db.collection('users').doc(rootState.user.uid).collection('textlinks');
    let batch = db.batch();

    var textlinks = this.getters.orderedTextlinks;
    var index=1;
    textlinks.forEach(textlink => {
      textlink.index = index++;
      let textlinkRef = textlinksRef.doc(textlink.id);
      batch.update(textlinkRef, {index:textlink.index });
    });

    batch.commit().then(function () {
      console.log('Salvou nova ordem');
    });

  },


  updateTextlink({state,commit,rootState},{textlink_id,data}){
    console.log(textlink_id,'textlink_id')
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const textlinksRef = db.collection('users').doc(rootState.user.uid).collection('textlinks');

    state.textlinks.forEach(textlink=>{
      if(textlink.id == textlink_id) {
        for (let field in data){
          textlink[field] = data[field];
        }
      }
      return textlink;
    });

    return textlinksRef.doc(textlink_id).update(data).then(()=>{
      console.log("updatetextlink OK");
      this.dispatch('queryTextlinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  addTextlink({state,commit,rootState},{data}){
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const textlinksRef = db.collection('users').doc(rootState.user.uid).collection('textlinks');

    if(!data.index){
      if(state.textlinks.length==0){
        data.index = 1;
      } else {
        data.index = state.textlinks[state.textlinks.length-1].index + 1;
      }
    }

    var tmp_id = new Date().getTime();
    state.textlinks.push({id:tmp_id,...data});

    return textlinksRef.add(data).then(()=>{
      console.log("addtextlink OK");
      this.dispatch('queryTextlinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  deleteTextlink({state,commit,rootState},{textlink_id}){

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const textlinksRef = db.collection('users').doc(rootState.user.uid).collection('textlinks');

    var indexDelete = null;
    state.textlinks.forEach((textlink,index)=>{
      if(textlink.id == textlink_id) {
        indexDelete = index;
      }
      return textlink;
    });
    state.textlinks.splice(indexDelete,1);

    return textlinksRef.doc(textlink_id).delete().then(()=>{
      console.log("deletetextlink OK");
      this.dispatch('queryTextlinks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

}
// Mutations
const mutations = {
  setTextlinks(state, data) {
    state.textlinks = data;
  },
}
export default {
  //namespaced: true,
  state,
  getters,
  actions,
  mutations
}